import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import {MoreNewsComponent} from "./more-news.component";
import {RouterModule} from "@angular/router";

@NgModule({
  imports: [
    CommonModule, RouterModule
  ],
  declarations: [MoreNewsComponent],
  exports: [MoreNewsComponent]
})
export class MoreNewsModule { }



// WEBPACK FOOTER //
// ./src/app/components/more-news/more-news.module.ts